var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"py-4"},[_c('h1',{staticClass:"h2 text-regular"},[_vm._v(" "+_vm._s(_vm.$t('login.title'))+" ")])]),_c('div',{staticClass:"py-4"},[_c('form-login',{on:{"logged":_vm.onLogged}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }